import React from 'react'
import { HotkeysTarget2 } from "@blueprintjs/core";


function LinkedInHK({
    url
}) {

    const openLI = () =>{
        window.open(url, "_blank")
    }
    
    const hotkeys = [
        {
            combo: "l",
            global: true,
            label: "Linkedin",
            onKeyDown: openLI,
        },
    ]

    return (
        <HotkeysTarget2 hotkeys={hotkeys}>
        {({ handleKeyDown, handleKeyUp }) => (
            <div onKeyDown={handleKeyDown} onKeyUp={handleKeyUp}>
                
            </div>
        )}
        </HotkeysTarget2>
    )
}

export default LinkedInHK
